import { FormField } from './FormField';
import styles from './NumberField.module.css';

export interface NumberFieldProps {
  label: string;
  id: string;
  value: number | '';
  onChange: (value: number | '') => void;
  min: number;
  max: number;
  name?: string;
  helpText?: string;
  error?: string;
}

/**
 * Integer stepper backed by a native `input[type=number]` with `min`/`max`/`step`.
 * The native constraints give keyboard/AT users first-class boundary handling; the
 * server remains authoritative (out-of-range → 422 field error).
 */
export function NumberField({
  label,
  id,
  value,
  onChange,
  min,
  max,
  name,
  helpText,
  error,
}: NumberFieldProps) {
  return (
    <FormField
      label={label}
      id={id}
      {...(helpText ? { helpText } : {})}
      {...(error ? { error } : {})}
    >
      {({ controlProps }) => (
        <input
          {...controlProps}
          className={styles.input}
          type="number"
          inputMode="numeric"
          name={name ?? id}
          min={min}
          max={max}
          step={1}
          value={value}
          onChange={(e) => {
            const raw = e.target.value;
            onChange(raw === '' ? '' : Number(raw));
          }}
        />
      )}
    </FormField>
  );
}
